<template>
<v-container fluid>
  <v-row dense>
    <v-col cols="12">
        <SearchDinamicField :itemAction="SearchInsumoField" :on-success="actionFieldData" />
        <!-- :setterModel="insumo" -->
    </v-col>
    <v-col cols="12">
      <DataTableMain
        :datatable="table"
        :on-success="successAction"
        :items-action="tableAction"
      />
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import DataTableMain from '@/components/tables/DataTableMain.vue'
import SearchDinamicField from '@/components/fields/SearchDinamicField.vue'

import axios from 'axios'
import { HeaderGral } from '@/store/modules/config'
export default {
  props: ['itemAction', 'onSuccess'],
  data: () => ({
    table: {
      modelMain: [],
      class_items: false,
      header: {
        options: [{ title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' }],
        filter: true,
        titles: [],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    SearchInsumoField: { field: 'searchDataServer', name: 'Insumos', nameid: 'inventario_id', url: '/inventarios/almacen/picking' },
    insumo: null
  }),
  components: {
    DataTableMain,
    SearchDinamicField
  },
  created () {
    this.table.class_items = this.itemAction.color_row
    this.table.header.titles = this.itemAction.titles
    // if (this.itemAction.url) {
    //   this.getDinamicData(this.itemAction.url)
    // } else {
    //   this.table.body.data = this.itemAction.items
    // }
  },
  methods: {
    getDinamicData (url) {
      this.table.header.loading = true
      const header = HeaderGral()
      axios.post(url, this.itemAction.data, header).then((response) => {
        this.table.body.data = response.data
      }).catch((error) => {
        if (error == null) console.log('Error')
      }).finally(() => {
        this.table.header.loading = false
      })
    },
    refreshData (item) {
      if (this.itemAction.url) {
        this.getDinamicData(this.itemAction.url)
      }
    },
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      return this[item.action](item)
    },

    InsumoRemoved ({ item }) {
      if ((item.utiliza - 1) > 0) {
        this.table.body.data.map(i => {
          if (i.folio === item.folio) {
            i.utiliza--
          }
        })
      } else this.table.body.data = this.table.body.data.filter(i => i.folio !== item.folio)

      this.onSuccess({ id: this.itemAction.nameid, data: this.table.body.data })
    },
    InsumoAdded ({ item }) {
      if ((item.utiliza + 1) <= item.cantidad) {
        this.table.body.data.map(i => {
          if (i.folio === item.folio) {
            i.utiliza++
          }
        })

        this.onSuccess({ id: this.itemAction.nameid, data: this.table.body.data })
      } else {
        this.$swal({
          type: 'warning',
          icon: 'warning',
          title: 'Advertencia !!',
          text: `la cantidad disponible es ${item.cantidad}, para utiliar`
        })
      }
    },
    rowColor ({ item }) {
      if (this.itemAction.nameid === 'article') {
        return (item.inventarios.picking <= 0) ? 'red-darken-1' : 'white'
      }
      return 'white'
    },
    actionFieldData ({ data, objetModel }) {
      if (data) {
        const exist = this.table.body.data.find(i => i.folio === objetModel.folio)
        if (!exist) {
          const item = {
            inventario_id: objetModel.id,
            folio: objetModel.folio,
            descripcion: objetModel.caracteristicas.descripcion,
            familia: objetModel.caracteristicas.familia.nombre,
            marca: objetModel.caracteristicas.marca.nombre,
            disponible: objetModel.inventarios.picking,
            cantidad: 1
          }
          this.table.body.data.push(item)
          this.onSuccess({ id: this.itemAction.nameid, data: this.table.body.data })
        } else {
          this.$swal({
            type: 'warning',
            icon: 'warning',
            title: 'Advertencia !!',
            text: 'el insumo, se encuentra agregado.',
            timer: 1500
          })
        }
      }
    }
  }
}
</script>
<style scoped>
</style>
